import { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useLocation, useSearchParams } from "react-router-dom";
import InvitedUsers from "./InvitedUsers";

const Invitations = () => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab") || "sent-invitations";
  const [activeTab, setActiveTab] = useState(tabFromUrl);
  const handleTabChange = (key) => {
    setActiveTab(key);
    setSearchParams({ tab: key });
  };
  useEffect(() => {
    const tab = searchParams.get("tab") || "sent-invitations";
    if (tab !== activeTab) setActiveTab(tab);
  }, [location.search]);
  return (
    <div
      className="scrollable-container"
      style={{
        height: "100%",
      }}
    >
      <h1>
        <strong>Invitations</strong>
      </h1>
      <Tabs
        activeKey={activeTab}
        onSelect={handleTabChange}
        id="invitations-tabs"
        className="mb-3"
      >
        <Tab eventKey="sent-invitations" title="Sent Invitations">
          <InvitedUsers type="sent" />
        </Tab>
        <Tab eventKey="received-invitations" title="Received Invitations">
          <InvitedUsers type="received" />
        </Tab>
      </Tabs>
    </div>
  );
};

export default Invitations;
